import z from "zod"

// strictly reject empty strings, expect nulls instead
// for simpler comparison
const notEmptyString = z.string().min(1)

export const ZOncologyItem = z.object({
	PrimaryTumor: z.nullable(notEmptyString),
	MetastaticSite: z.nullable(notEmptyString),
	TreatmentStatus: notEmptyString,
	ICD10_1_Eval: notEmptyString,
	ICD10_2_Eval: z.nullable(notEmptyString),
	ICD10_1_Description: notEmptyString,
	ICD10_2_Description: z.nullable(notEmptyString),
})
export type OncologyItem = z.infer<typeof ZOncologyItem>
